/* import __COLOCATED_TEMPLATE__ from './dependencies-modal-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();